<div data-content="two" class="take-action-tab active">

  <div class="omne-card doc_inbox">
    <div class="inbox-header col-lg-12 pd-0 d-flex flex-wrap justify-content-between pdy-2">
      <div class="col-lg-3 d-flex align-items-center">
        <h4 class="pd-0 mg-0">Inbox</h4>
      </div>
      <div class="col-lg-9 d-flex flex-wrap justify-content-start">
        <div class="col-lg-6 pd-0 mgr-lg-5">
          <div class="form-group mgb-3 mgb-lg-0">
            <!-- <label for="SearchInput">Search Input with Icon</label> -->
            <span class="has-icon">
              <input type="text" id="SearchName" [(ngModel)]="Search.search" (keyup.enter)="SearchByCandidateandClientName()" class="form-control"
                     placeholder="Search by Candidate and Client Name" value="">
              <i class="con">
                <button class="bg-none border-0 font-20 pe-all outline-none" (click)="SearchByCandidateandClientName()" data-tooltip="Search" data-tooltip-location="bottom">
                  <i class="fa-regular fa-magnifying-glass"></i>
                </button>
                <button class="bg-none border-0 font-24 pe-all outline-none" (click)="ResetSearchParameter()" data-tooltip="Reset" data-tooltip-location="bottom">
                  <i class="fa-regular fa-xmark"></i>
                </button>
              </i>
            </span>
          </div>
        </div>
      </div>

    </div>
    <div class="clearfix clear-fix"></div>
    <div class="table_wrap inbox-table-main accordion pd-3 table-respo" id="accordion1">
      <div class="custom_table_head">
        <div class="custom_tr row accordion-group">
          <div class="custom_th colw-2">&nbsp;</div>
          <div class="custom_th colw-16">Candidate Name</div>
          <div class="custom_th colw-17">Subject</div>
          <div class="custom_th colw-14 text-left">Client Name</div>

          <div class="custom_th colw-11 text-left"> Start Date</div>
          <div class="custom_th colw-16 text-center">Received From</div>
          <div class="custom_th colw-13 text-center">Received Date</div>
          <!-- <div class="custom_th colw-6">Status</div> -->
          <div class="custom_th colw-3">&nbsp;</div>
          <div class="custom_th colw-3">&nbsp;</div>
          <div class="custom_th colw-3">&nbsp;</div>
        </div>
      </div>
      <!-- <div class="accordion-group accordion-level1 custom_tr" style="text-align: center;"  *ngIf="VendorConsultantPackegeList.length==0">
        <p class="font-12 text-color-pink"> You dont have any pending paperwork to sign</p>
      </div> -->
      <div class="accordion-group accordion-level1 custom_tr" *ngFor="let item of VendorConsultantPackegeList;let i = index">
        <div class="accordion-heading closed">
          <div class="custom_tr row collapsed">
            <div class="custom_td colw-2 pdx-0" *ngIf="envMastIds[i].envMstrID==evMastID" data-tooltip="Click to collapse" data-tooltip-location="right">
              <a data-toggle="collapse" (click)="getConsultantDocList(item.taskId,item.envMstrID,i)" data-parent="#accordion2"
                 href="#collapse{{item.envMstrID}}" [ngClass]="envMastIds[i].envMstrID==evMastID ? 'accordion-toggle plus-toggle d-inline-block mgx-auto' : 'accordion-toggle plus-toggle collapsed d-inline-block mgx-auto'"
                 aria-expanded="false">&nbsp;</a>
            </div>
            <div class="custom_td colw-2 pdx-0" *ngIf="envMastIds[i].envMstrID!=evMastID" data-tooltip="Click to expand" data-tooltip-location="right">
              <a data-toggle="collapse" (click)="getConsultantDocList(item.taskId,item.envMstrID,i)" data-parent="#accordion2"
                 href="#collapse{{item.envMstrID}}" [ngClass]="envMastIds[i].envMstrID==evMastID ? 'accordion-toggle plus-toggle d-inline-block mgx-auto' : 'accordion-toggle plus-toggle collapsed d-inline-block mgx-auto'"
                 aria-expanded="false">&nbsp;</a>
            </div>
            <div class="custom_td colw-16 pdl-2">{{item.candidateName}}</div>
            <div class="custom_td colw-17 line-limit only-lines-2"
                 data-tooltip-location="top" [attr.data-tooltip]="item.subject">
              {{item.subject | slice:0:60}}...
            </div>
            <div class="custom_td colw-14 text-left" data-tooltip-location="top" [attr.data-tooltip]="item.clientName">
              {{item.clientName | slice:0:20}}...
            </div>

            <div class="custom_td colw-11 text-left">{{item.startDate}}</div>
            <div class="custom_td colw-16 text-left" data-tooltip-location="top" [attr.data-tooltip]="item.admin_Email">{{item.admin_Email | slice:0:20}}...</div>
            <div class="custom_td colw-13 text-left">{{item.sentDate}}</div>
            <!-- <div class="custom_td colw-6">{{item.status}}</div> -->
            <div class="custom_td colw-3">
              <div class="table_actions">
                <span class="modal_open" data-tooltip="View Email" data-tooltip-location="bottom"
                      data-modalname="emailWrap{{item.envMstrID}}">
                  <img src="../assets/images/icons/ic-mail-action.svg"
                       [className]="'block'" (click)="emailWrapPopup(item.emailLogId)" alt="ic-mail">
                </span>
              </div>
            </div>
            <div class="custom_td colw-3">
              <div class="table_actions">
                <span class="info-tooltip" data-tooltip="View POC" data-tooltip-location="bottom">
                  <img class="open_popup" src="../assets/images/icons/ic-person-action.svg" alt="ic-person">
                  <div class="action_popup withLogo">
                    <div class="col-sm-12 pd-0 pdy-3 d-flex flex-wrap">
                      <div class="col-lg-3 text-center float-none d-flex align-items-center justify-content-center bsr-1">
                        <img class="" src="../assets/images/ascendion-logo-white.svg" alt="">
                      </div>
                      <div class="col-lg-9 float-none pdx-0">
                        <div class="popup_header border-0">
                          <h6 class="">Onboarding Contact</h6>
                          <span class="close_popup">
                            <i class="fa-regular fa-xmark font-18 color-white" id="closePocPopup{{i}}"></i>
                          </span>
                        </div>
                        <div class="popup_body pdt-0">
                          <div class="row">
                            <div class="col-sm-12 d-flex flex-wrap rej_req_info">
                              <span class="icon-block">
                                <img src="../assets/images/icons/ic-person.svg" alt="ic-person">
                              </span>
                              <span class="details-block pdt-1 pdl-1">
                                <p>{{item.admin}}</p>
                                <small>{{item.job_Title}}</small>
                              </span>
                            </div>
                            <div class="col-sm-12 d-flex flex-wrap rej_req_info">
                              <span class="icon-block">
                                <img src="../assets/images/icons/ic-mail.svg" alt="ic-person">
                              </span>
                              <span class="details-block pdt-1 pdl-1">
                                <p>
                                  <a (click)="SendEmailPopup(item.admin_Email,item.taskId,item.candidateName,item.vendorName,i)" data-tooltip="Send mail" data-tooltip-location="bottom">{{item.admin_Email}}</a>
                                </p>
                              </span>
                            </div>
                            <div class="col-sm-12 d-flex flex-wrap rej_req_info">
                              <span class="icon-block">
                                <img src="../assets/images/icons/ic-contact.svg" alt="ic-person">
                              </span>
                              <span class="details-block phone pdt-1 pdl-1">
                                <p>
                                  <a href="tel:{{item.admin_Phone}}">{{item.admin_Phone}}</a>
                                </p>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            </div>
            <div class="custom_td colw-3">
              <div class="table_actions">
                <span class="modal_open" data-tooltip="Unpin Email" data-tooltip-location="bottom" *ngIf="item.isPin">
                  <img src="../assets/images/icons/ic-pin-active.svg" alt="ic-pin-active.svg"
                       (click)="InsUpdPinOnPackage(item.envMstrID,item.taskId,item.emailLogId,item.pinID)">
                </span>
                <span class="modal_open" data-tooltip="Pin Email" data-tooltip-location="bottom" *ngIf="!item.isPin">
                  <img src="../assets/images/icons/ic-pin-unactive.svg" alt="ic-pin-active.svg"
                       (click)="InsUpdPinOnPackage(item.envMstrID,item.taskId,item.emailLogId,item.pinID)">
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="custom_modal" id="emailWrap{{item.envMstrID}}" [ngClass]="emailWrapStyle[item.emailLogId]">
          <div class="custom_modal_wrap">
            <div class="custom_modal_header">
              <h5 class="modal-title">Email Message</h5>
              <button class="close">
                <span>
                  <img src="../../assets/images/icons/ic-close.svg" alt="ic-close"
                       (click)="emailWrapPopup(item.emailLogId)" />
                </span>
              </button>
            </div>
            <div class="custom_modal_body">
              <div class="email_ttile d-flex align-items-center">
                <p>{{item.subject}}</p>
                <!-- <ul class="d-flex align-items-center ml-auto">
                  <li>
                    <img src="../../assets/images/icons/ic-mail-grey.svg" alt="ic-mail-grey" />
                  </li>
                  <li>
                    <img src="../../assets/images/icons/ic-replay.svg" alt="ic-replay" />
                  </li>
                  <li>
                    <img src="../../assets/images/icons/ic-replayall.svg" alt="ic-replayall" />
                  </li>
                  <li>
                    <img src="../../assets/images/icons/ic-forward.svg" alt="ic-forward" />
                  </li>
                  <li>
                    <img src="../../assets/images/icons/ic-mark.svg" alt="ic-mark" />
                  </li>
                </ul> -->
              </div>
              <div class="email_det">
                <div class="row">
                  <div class="col-sm-12 mail_details">
                    <table>
                      <tr>
                        <td>
                          <b>From : &nbsp;</b>
                        </td>
                        <td>
                          {{item.mailFrom}}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <b>On : </b>
                        </td>
                        <td>
                          {{item.sentDate | date: 'MM-dd-yyyy hh:mm:ss'}}
                        </td>
                      </tr>
                      <tr>
                        <td><b>To : &nbsp; </b></td>
                        <td>{{item.emailId}}</td>
                      </tr>
                      <tr>
                        <td><b>CC : &nbsp; </b></td>
                        <td style="word-break: break-all;">{{item.mailCC}}</td>
                      </tr>
                    </table>
                  </div>
                  <!-- <div class="col-sm-6 mail_attach">
                    <div class="attachment_details">
                      <img src="../../assets/images/icons/ic-attach.svg" alt="ic-attach" />
                      Attachment.docx
                      <img class="ml-auto" src="../../assets/images/icons/ic-download.svg" alt="ic-download" />
                    </div>
                  </div> -->
                </div>
              </div>
              <div class="email_subject">
                <div class="editable" [innerHTML]="sanitizer.bypassSecurityTrustHtml(item.body)"></div>
              </div>
            </div>
          </div>
        </div>
        <div id="collapse{{item.envMstrID}}" *ngIf="envMastIds[i].envMstrID==evMastID" class="{{rowCollCss}}" aria-expanded="false">
          <div class="row mg-0 mgb-5" *ngIf="ConsultantModifiedList.length>0">
            <div class="col-md-3 pdl-0" id="leftContentContainer">
              <div class="exp_sidebar col-sm-12 box" style="height: 100%;">
                <h3 class="mgt-0 mgb-4">eSignature Enabled</h3>
                <div class="docs_mainwrap active mgb-2" *ngFor="let mainItem of ConsultantModifiedList;let ind = index">
                  <div class="accord-head col-12 pd-0">
                    <b class="d-flex justify-content-between" (click)="CreateEnvelope(mainItem.DocList,mainItem.DocCategory,0,mainItem.envelop_Pid)">
                      {{mainItem.DocCategory}}
                      <a class="text-color-white pdl-2 bg-none" href="#col_doc{{mainItem.SNO}}01" data-toggle="collapse" aria-expanded="true">
                        <i class="fa-regular fa-angle-up"></i>
                      </a>
                    </b>
                  </div>
                  <div class="docs_wrap collapse in" id="col_doc{{mainItem.SNO}}01">
                    <ul *ngFor="let subItem of mainItem.DocList" class="list-style-none pd-0 mg-0">
                      <li *ngIf="subItem.Doc_Status=='AdminReject' || subItem.Doc_Status=='Rejected'" class="pdy-2 pdx-0 d-flex justify-content-between align-content-center">
                        <span style="color: red;">
                          <i class="fa-solid fa-circle-dot pdl-2 pdr-2"></i>
                          {{subItem.DocName}}
                        </span>
                        <span class="pdl-2 pdr-2 d-flex align-items-center">
                          <!-- <span class="workorder-count cursor-pointer pd-0 font-12" data-tooltip="Uploaded supporting documents" data-tooltip-location="bottom">{{subItem.supportingdocscount}}</span> -->
                          <span class="has-popover d-inline-block cursor-pointer mgx-2" data-tooltip="Please click to view the rejection reason" data-tooltip-location="bottom">
                            <img src="../../assets/images/icons/ic-rejected.svg"
                                 alt="ic-rejected"
                                 *ngIf="subItem.Doc_Status=='AdminReject'|| subItem.Doc_Status=='Rejected'"
                                 class="mgx-2"
                                 (click)="RejectionInfoPopup(subItem.DocID, $event)" />
                            <div class="popover-info width-250 width-lg-350 align-left pd-0">
                              <div class="popover-info--head col-lg-12 d-flex align-items-center pdx-3 pdy-2">
                                <h6 class="mg-0 font-12">Rejection Notes</h6>
                                <button class="bg-none border-0 font-16 mgl-auto" (click)="RejectionInfoPopup('close', $event)">
                                  <i class="fa-light fa-xmark text-color-white"></i>
                                </button>
                              </div>
                              <div class="popover-info--body col-lg-12 pd-3">
                                <!-- <div class="col-lg-12 pd-0 text-color-yellow font-10 pdb-3">Note: For HP and HP Non-IT clients, “No
                                    Per Diem is Allowed”</div> -->
                                <div class="col-lg-12 pd-0 d-flex flex-wrap" *ngFor="let OPS of RejectionHistoryOPS">
                                  <div class="col-lg-6 pd-0">
                                    <div class="form-group">
                                      <label class="mg-0 pd-0 text-color-green2 font-10 text-color-green2">Rejected Date</label>
                                      <p class="mg-0 pd-0 text-color-white font-10">{{OPS.RejectedDate}}</p>
                                    </div>
                                  </div>
                                  <div class="col-lg-6 pd-0">
                                    <div class="form-group">
                                      <label class="mg-0 pd-0 text-color-green2 font-10 text-color-green2">Rejected By</label>
                                      <p class="mg-0 pd-0 text-color-white font-10">{{OPS.RejectedBy}}</p>
                                    </div>
                                  </div>
                                  <div class="col-lg-12 pd-0">
                                    <div class="form-group">
                                      <label class="mg-0 pd-0 text-color-green2 font-10 text-color-green2">Notes</label>
                                      <p class="mg-0 pd-0 text-color-white font-10">{{OPS.Reject_Reason}}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!-- <div class="popover-info--footer col-lg-12 pd-3">
                                <h6>footer content goes here</h6>
                              </div> -->
                            </div>
                          </span>
                          <!-- <span
                            (click)="OpenSupportDocPopup(item.taskId,0,subItem.DocID,subItem.DocName)"
                            class="d-inline-block cursor-pointer mgx-2"
                            data-modalname="supportingDocs"
                            data-tooltip="Upload supporting documents" data-tooltip-location="bottom"
                            alt="ic-upload-latest.svg">
                              <i class="fa-regular fa-paperclip font-16 text-color-action"></i>
                          </span>
                          <span class="workorder-count cursor-pointer pd-0 font-12" data-tooltip="Uploaded supporting documents" data-tooltip-location="bottom">{{subItem.supportingdocscount}}</span>  -->
                        </span>
                      </li>
                      <li *ngIf="subItem.Doc_Status!='AdminReject' && subItem.Doc_Status!='Rejected'" class="active cursor-pointer pdy-2 pdx-0 d-flex justify-content-between align-content-center">
                        <a (click)="CreateEnvelope(mainItem.DocList,mainItem.DocCategory,subItem.DocID,mainItem.envelop_Pid)">
                          <i class="fa-solid fa-circle-dot pdl-2 pdr-2"></i>
                          {{subItem.DocName}}
                        </a>
                        <span class="pdl-2 pdr-2 d-flex align-items-center">
                          <span class="has-popover d-inline-block cursor-pointer mgx-2" data-tooltip="Please click to view the rejection reason" data-tooltip-location="bottom">
                            <img src="../../assets/images/icons/ic-rejected.svg"
                                 alt="ic-rejected"
                                 *ngIf="subItem.reject_reason!=null"
                                 class="mgx-2"
                                 (click)="RejectionInfoPopup(subItem.DocID, $event)" />
                            <div class="popover-info width-250 width-lg-350 align-left pd-0">
                              <div class="popover-info--head col-lg-12 d-flex align-items-center pdx-3 pdy-2">
                                <h6 class="mg-0 font-12">Rejection Notes</h6>
                                <button class="bg-none border-0 font-16 mgl-auto" (click)="RejectionInfoPopup('close', $event)">
                                  <i class="fa-light fa-xmark text-color-white"></i>
                                </button>
                              </div>
                              <div class="popover-info--body col-lg-12 pd-3">
                                <!-- <div class="col-lg-12 pd-0 text-color-yellow font-10 pdb-3">Note: For HP and HP Non-IT clients, “No
                                    Per Diem is Allowed”</div> -->
                                <div class="col-lg-12 pd-0 d-flex flex-wrap" *ngFor="let OPS of RejectionHistoryOPS">
                                  <div class="col-lg-6 pd-0">
                                    <div class="form-group">
                                      <label class="mg-0 pd-0 text-color-green2 font-10 text-color-green2">Rejected Date</label>
                                      <p class="mg-0 pd-0 text-color-white font-10">{{OPS.RejectedDate | date: 'MM-dd-yyyy hh:mm:ss'}}</p>
                                    </div>
                                  </div>
                                  <div class="col-lg-6 pd-0">
                                    <div class="form-group">
                                      <label class="mg-0 pd-0 text-color-green2 font-10 text-color-green2">Rejected By</label>
                                      <p class="mg-0 pd-0 text-color-white font-10">{{OPS.RejectedBy}}</p>
                                    </div>
                                  </div>
                                  <div class="col-lg-12 pd-0">
                                    <div class="form-group">
                                      <label class="mg-0 pd-0 text-color-green2 font-10 text-color-green2">Notes</label>
                                      <p class="mg-0 pd-0 text-color-white font-10">{{OPS.Reject_Reason}}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!-- <div class="popover-info--footer col-lg-12 pd-3">
                                <h6>footer content goes here</h6>
                              </div> -->
                            </div>
                          </span>

                          <span class="workorder-count cursor-pointer pd-0 font-12" data-tooltip="Uploaded supporting documents" data-tooltip-location="bottom">{{subItem.supportingdocscount}}</span>
                          <span (click)="OpenSupportDocPopup(item.taskId,0,subItem.DocID,subItem.DocName)"
                                class="d-inline-block cursor-pointer mgx-2"
                                data-modalname="supportingDocs"
                                data-tooltip="Upload supporting documents" data-tooltip-location="bottom"
                                alt="ic-upload-latest.svg">
                            <i class="fa-regular fa-paperclip font-16 text-color-action"></i>
                          </span><!-- <img src="../assets/images/icons/ic-upload-latest.svg" alt="ic-upload-latest.svg"> -->
                          <!-- <i class="fa-regular fa-paperclip font-14 text-color-action"></i> -->
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>

                <a class="support_docs modal_open text-color-action"
                   (click)="OpenSupportDocPopup(item.taskId,item.envMstrID,0,'')"
                   data-modalname="supportingDocs">
                  <span class="pdl-2 pdr-2">
                    <img src="../assets/images/icons/ic-upload-latest.svg" alt="ic-upload-latest.svg">
                  </span>
                  Supporting Documents
                  <span class="pdl-2">{{totalUploadedSupportingDocs}}</span>
                  <span class="pdl-3">
                    <img src="../assets/images/icons/ic-double-right-angle.svg" alt="ic-double-right-angle.svg">
                  </span>
                </a>
              </div>
            </div>
            <div class="col-md-9 box pdr-0" id="rightContentContainer" style="height: auto;">
              <div class="col-lg-12 pd-0">
                <div class="col-sm-12 pd-0 mgb-3 text-right d-flex flex-wrap align-items-center">
                  <div class="col-lg-6 pd-0">
                    <p class="pd-0 mg-0 text-left font-12 text-color-pink" *ngIf="!IsEsign && !IsWorkOrderRejected"><i class="fa-solid fa-triangle-exclamation"></i> Please review & fill the document</p>
                    <!-- <p class="pd-0 mg-0 text-left font-12 text-color-pink"><i class="fa-solid fa-triangle-exclamation"></i> Plese review & click Next to move forward</p> -->
                  </div>
                  <div class="col-lg-6 pd-0">
                    <span class="d-inline-block" *ngIf="IsReviewDivVisible && !IsDocSignIFrameVisible">
                      <button type="submit" *ngIf="(CurrentEsignDocIndex>0)? true:false" class="obtn obtn-primary obtn-lg esign-btn" (click)="Previous()">
                        Previous
                      </button>
                      <button *ngIf="((CurrentEsignDocIndex<CurrentEsignDocLength)? true:false) && IsNext" class="obtn obtn-primary obtn-lg esign-btn" (click)="SubmitAndNext('')">
                        Next
                      </button>
                    </span>
                    <!-- <button
                      *ngIf="IsBeginProcess"
                      class="obtn obtn-primary obtn-lg esign-btn"
                      (click)="onClickOnBeginProcess('')"
                      type="button">
                      <img class="mgr-2" src="../assets/images/icons/ic-action_sign.svg" alt="ic-action_sign">
                      Begin Process
                    </button> -->
                    <!-- *ngIf="IsEsign" -->
                    <!-- <button
                      class="obtn obtn-primary obtn-lg esign-btn mgl-3 modal_open"
                      data-modalname="dummymodal"
                      type="button">
                        dummy
                    </button> -->
                    <button *ngIf="IsEsign" data-tooltip=" Thank you for submitting the WO, please Esign now." data-tooltip-location="left"
                            class="obtn obtn-primary obtn-lg esign-btn mgl-3"
                            data-modalname="InfoPopupForEsignModal"
                            (click)="onClickOnEsignProcess()"
                            type="button">
                      <img class="mgr-2" src="../assets/images/icons/ic-action_sign.svg" alt="ic-action_sign">
                      Esign
                    </button>
                  </div>
                </div>
                <div class="clearfix clear-fix"></div>
                <div class="doc-holderdiv col-lg-12 pd-0 mgx-auto float-none" id="holderdiv">
                  <!-- <img src="../assets/images/request-for.jpeg" class="img-fluid w_100" alt="group-3"> -->
                  <div id="container" *ngIf="IsReviewDivVisible">
                    <iframe [src]="DocsUrl" id="testIFrame" width="100%" height="840" *ngIf="IsReviewIFrameVisible" style="border:0;" allowfullscreen="true"
                            loading="lazy">
                    </iframe>
                    <div id="DivWOrderHtml" #DivworkorderHtml width="100%" *ngIf="IsFillableDivVisible" style="border: solid 1px #000; background-color: white; overflow:auto; height:1160px;">
                      <app-workorder [expectedProp]="forWorkOrderTempValue" (parentFun)="parentFunForWorkOrder($event)"></app-workorder>
                    </div>
                    <div id="DivWOrderHtml2" #DivworkorderHtml2 width="100%" *ngIf="IsFillableDivVisibleForSP" style="border: solid 1px #000; background-color: white; overflow:auto; height:1160px;">
                      <app-workorder-special [expectedProp]="forWorkOrderTempValue" (parentFun)="parentFunForWorkOrder($event)"></app-workorder-special>
                    </div>
                    <div id="DivWOrderHtml3" #DivworkorderHtml3 width="100%" *ngIf="IsFillableDivVisibleForCN" style="border: solid 1px #000; background-color: white; overflow:auto; height:1160px;">
                      <app-workorder-canada [expectedProp]="forWorkOrderTempValue" (parentFun)="parentFunForWorkOrder($event)"></app-workorder-canada>
                    </div>
                    <div id="DivDocHtml" #DivDocHtml [innerHTML]="DocHtml" width="100%" *ngIf="IsReviewSubDivVisible" style="border: solid 1px #000; background-color: white; overflow:auto; height:1160px;"></div>
                  </div>
                  <br />
                  <div class="ef_nav d-flex align-items-right" style="justify-content: flex-end;" id="divsubmit" *ngIf="IsReviewDivVisible && !IsDocSignIFrameVisible">
                    <button type="submit" *ngIf="(CurrentEsignDocIndex>0)? true:false" class="obtn obtn-primary obtn-lg esign-btn" (click)="Previous()">
                      Previous
                    </button>
                    <button *ngIf="((CurrentEsignDocIndex<CurrentEsignDocLength)? true:false) && IsNext" class="obtn obtn-primary obtn-lg esign-btn mgl-5" (click)="SubmitAndNext('')">
                      Next
                    </button>
                    <!--<button *ngIf="(CurrentEsignDocIndex>=CurrentEsignDocLength)? true:false && !IsFillableDivVisible" class="esign_btn" (click)="Submit()">
                      Submit
                    </button>&nbsp;&nbsp;
                    <button class="esign_btn modal_open" data-modalName="reject_notes_modal" *ngIf="(CurrentEsignDocIndex<CurrentEsignDocLength)? true:false" (click)="RejectPopupOpen('RejectAndGoNext')">
                      Reject And Go Next
                    </button>&nbsp;&nbsp;
                    <button class="esign_btn modal_open" data-modalName="reject_notes_modal" *ngIf="(CurrentEsignDocIndex>=CurrentEsignDocLength)? true:false" (click)="RejectPopupOpen('Reject')">
                      Reject
                    </button>                 -->
                  </div>
                </div>
              </div>
              <div class="verticalHandle opened"></div>
              <div class="clearfix clear-fix"></div>
            </div>
          </div>

          <div class="clearfix clear-fix"></div>
          <div class="physicalsign_doc mgb-3" id="physicaldiv" *ngIf="PhysicalSignatureDownloadDocList.length>0">
            <!-- <p-panel header="Physical Signature Required" [toggleable]="true"> -->
            <h4 class="">Physical Signature Required</h4>
            <p>Due to client policy or regulatory reasons, please physically sign</p>
            <div class="table_wrap">
              <div class="custom_table_head">
                <div class="custom_tr row">
                  <div class="custom_th col-sm-4">Document</div>
                  <div class="custom_th col-sm-2">Download</div>
                  <div class="custom_th col-sm-2">Upload</div>
                  <div class="custom_th col-sm-4"></div>
                </div>
              </div>
              <div class="custom_table_body" *ngFor="let item of PhysicalSignatureDownloadDocList">
                <div class="custom_tr row">
                  <div class="custom_td col-sm-4">
                    {{item.actual_Form_Name}}
                  </div>
                  <div class="custom_td col-sm-2">
                    <span data-tooltip="Download document uploaded by OPS" data-tooltip-location="bottom">
                      <img src="../assets/images/icons/ic-download-latest.svg" alt="ic-download-latest"
                           (click)="DownloadFile(item.sent_doc,item.uploadedFileName)" />
                    </span>
                    <!-- <span><img src="../assets/images/icons/ic-download-latest.svg" alt="ic-download-latest"></span> -->
                  </div>
                  <div class="custom_td col-sm-2">
                    <span data-tooltip="Upload document" data-tooltip-location="bottom" class="modal_open" data-modalName="physicalDocs">
                      <img src="../assets/images/icons/ic-upload-latest.svg" alt="ic-upload-latest"
                           (click)="OpenphysicalSignatureDocsPopup(item.doc_id,item.envelop_Pid,item.actual_Form_Name)" />
                    </span>
                    <!-- <span class="modal_open" data-modalname="physicalDocs"><img src="../assets/images/icons/ic-upload-latest.svg" alt="ic-upload-latest"></span> -->
                  </div>
                  <div class="custom_td col-sm-4" *ngIf="item.reject_Reason!=null">
                    <span class="has-popover d-inline-block cursor-pointer mgx-2" data-tooltip="Please click to view the rejection reason" data-tooltip-location="bottom">
                      <img src="../../assets/images/icons/ic-rejected.svg"
                           alt="ic-rejected"
                           class="mgx-2"
                           (click)="RejectionInfoPopup(item.doc_id, $event)" />
                      <div class="popover-info width-250 width-lg-350 align-right pd-0 text-left">
                        <div class="popover-info--head col-lg-12 d-flex align-items-center pdx-3 pdy-2">
                          <h6 class="mg-0 font-12">Rejection Notes</h6>
                          <button class="bg-none border-0 font-16 mgl-auto" (click)="RejectionInfoPopup('close', $event)">
                            <i class="fa-light fa-xmark text-color-white"></i>
                          </button>
                        </div>
                        <div class="popover-info--body col-lg-12 pd-3">
                          <!-- <div class="col-lg-12 pd-0 text-color-yellow font-10 pdb-3">Note: For HP and HP Non-IT clients, “No
                              Per Diem is Allowed”</div> -->
                          <div class="col-lg-12 pd-0 d-flex flex-wrap" *ngFor="let OPS of RejectionHistoryOPS">
                            <div class="col-lg-6 pd-0">
                              <div class="form-group">
                                <label class="mg-0 pd-0 text-color-green2 font-10 text-color-green2">Rejected Date</label>
                                <p class="mg-0 pd-0 text-color-white font-10">{{OPS.RejectedDate | date: 'MM-dd-yyyy hh:mm:ss'}}</p>
                              </div>
                            </div>
                            <div class="col-lg-6 pd-0">
                              <div class="form-group">
                                <label class="mg-0 pd-0 text-color-green2 font-10 text-color-green2">Rejected By</label>
                                <p class="mg-0 pd-0 text-color-white font-10">{{OPS.RejectedBy}}</p>
                              </div>
                            </div>
                            <div class="col-lg-12 pd-0">
                              <div class="form-group">
                                <label class="mg-0 pd-0 text-color-green2 font-10 text-color-green2">Notes</label>
                                <p class="mg-0 pd-0 text-color-white font-10">{{OPS.Reject_Reason}}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- <div class="popover-info--footer col-lg-12 pd-3">
                          <h6>footer content goes here</h6>
                        </div> -->
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <!-- </p-panel> -->
          </div>
          <div class="clearfix clear-fix"></div>
          <div class="physicalsign_doc mgb-3" id="additionaldiv" *ngIf="AdditionalDocsList.length>0">
            <!-- <p-panel header="Physical Signature Required" [toggleable]="true"> -->
            <h4 class="">Additional Documents Required</h4>
            <!-- <p>Due to client policy or regulatory reasons, please physically sign</p> -->
            <div class="table_wrap">
              <div class="custom_table_head">
                <div class="custom_tr row">
                  <div class="custom_th col-sm-4">Document</div>
                  <!-- <div class="custom_th col-sm-2">Download</div> -->
                  <div class="custom_th col-sm-2">Upload</div>
                  <div class="custom_th col-sm-4"></div>
                </div>
              </div>
              <div class="custom_table_body" *ngFor="let item of AdditionalDocsList">
                <div class="custom_tr row">
                  <div class="custom_td col-sm-4">
                    {{item.actual_Form_Name}}
                  </div>
                  <!-- <div class="custom_td col-sm-2">
                    <span><img src="../assets/images/icons/ic-download-latest.svg" alt="ic-download-latest"
                        (click)="DownloadUploadedDoc(item.uploadedFileData,item.uploadedFileName)" /></span>
                    <span><img src="../assets/images/icons/ic-download-latest.svg" alt="ic-download-latest"></span>
                  </div>-->
                  <div class="custom_td col-sm-2">
                    <span data-tooltip="Upload document" data-tooltip-location="bottom" class="modal_open" data-modalName="additionalDocs">
                      <img src="../assets/images/icons/ic-upload-latest.svg" alt="ic-upload-latest"
                           (click)="OpenAdditionalDocsPopup(item.doc_id,item.actual_Form_Name)" />
                    </span>
                    <!-- <span class="modal_open" data-modalname="physicalDocs"><img src="../assets/images/icons/ic-upload-latest.svg" alt="ic-upload-latest"></span> -->
                  </div>
                  <div class="custom_td col-sm-4" *ngIf="item.reject_Reason!=null">
                    <span class="has-popover d-inline-block cursor-pointer mgx-2" data-tooltip="Please click to view the rejection reason" data-tooltip-location="bottom">
                      <img src="../../assets/images/icons/ic-rejected.svg"
                           alt="ic-rejected"
                           class="mgx-2"
                           (click)="RejectionInfoPopup(item.doc_id, $event)" />
                      <div class="popover-info width-250 width-lg-350 align-right pd-0 text-left">
                        <div class="popover-info--head col-lg-12 d-flex align-items-center pdx-3 pdy-2">
                          <h6 class="mg-0 font-12">Rejection Notes</h6>
                          <button class="bg-none border-0 font-16 mgl-auto" (click)="RejectionInfoPopup('close', $event)">
                            <i class="fa-light fa-xmark text-color-white"></i>
                          </button>
                        </div>
                        <div class="popover-info--body col-lg-12 pd-3">
                          <!-- <div class="col-lg-12 pd-0 text-color-yellow font-10 pdb-3">Note: For HP and HP Non-IT clients, “No
                              Per Diem is Allowed”</div> -->
                          <div class="col-lg-12 pd-0 d-flex flex-wrap" *ngFor="let OPS of RejectionHistoryOPS">
                            <div class="col-lg-6 pd-0">
                              <div class="form-group">
                                <label class="mg-0 pd-0 text-color-green2 font-10 text-color-green2">Rejected Date</label>
                                <p class="mg-0 pd-0 text-color-white font-10">{{OPS.RejectedDate | date: 'MM-dd-yyyy hh:mm:ss'}}</p>
                              </div>
                            </div>
                            <div class="col-lg-6 pd-0">
                              <div class="form-group">
                                <label class="mg-0 pd-0 text-color-green2 font-10 text-color-green2">Rejected By</label>
                                <p class="mg-0 pd-0 text-color-white font-10">{{OPS.RejectedBy}}</p>
                              </div>
                            </div>
                            <div class="col-lg-12 pd-0">
                              <div class="form-group">
                                <label class="mg-0 pd-0 text-color-green2 font-10 text-color-green2">Notes</label>
                                <p class="mg-0 pd-0 text-color-white font-10">{{OPS.Reject_Reason}}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- <div class="popover-info--footer col-lg-12 pd-3">
                          <h6>footer content goes here</h6>
                        </div> -->
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <!-- </p-panel> -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="clear-fix clearfix"></div>
</div>
<div class="custom_modal" id="InfoPopupForEsignModal" [ngStyle]="{'display':InfoPopupForEsign}">
  <div class="custom_modal_wrap custom_modal-width-mdsm">
    <div class="custom_modal_header pd-0" style="border-bottom: none;">
      <!-- <button class="close" style="position: absolute; top: 8px; right: 8px;">
        <span><img src="../assets/images/icons/ic-close.svg" alt="ic-close" /></span>
      </button> -->
    </div>
    <div class="custom_modal_body text-center pd-3">
      <p class="font-18"><img style="width: 20px; height: 20px; margin-right: 16px;" src="../assets/images/square-loader-trimmed.gif" alt="ic-close" /> Loading...</p>
      <p class="font-14">Thank you for reviewing the documents. These documents need to be esigned to complete the process.</p>
      <p class="font-14">Please wait while we take you into the esignature tool. This is the final step required for you to complete the esignature process</p>
    </div>
  </div>
</div>
<div class="custom_modal" id="docuSignPopup" [ngStyle]="{'display':DocuSignPopupStyle}">
  <div class="custom_modal_wrap docusign-modal-popup-fullwidth-fullheight">
    <div class="custom_modal_header">
      <button class="close">
        <span><img src="../assets/images/icons/ic-close.svg" alt="ic-close" (click)="OpenDocuSignPopup()" /></span>
      </button>
    </div>
    <div class="custom_modal_body">
      <iframe [src]="DocuSignUrl" id="DocuSignIFrame" width="100%" height="100%" style="border:0;" allowfullscreen="true"
              loading="lazy">
      </iframe>
    </div>
  </div>
</div>
<div class="custom_modal" id="physicalDocs" [ngStyle]="{'display':PhysicalSignatureStyle}">
  <div class="custom_modal_wrap custom_modal-width-md">
    <div class="custom_modal_header">
      <h5 class="modal-title">Upload Physical Signature Documents</h5>
      <button class="close">
        <span>
          <img src="../assets/images/icons/ic-close.svg" alt="ic-close"
               (click)="OpenphysicalSignatureDocsPopup()">
        </span>
      </button>
    </div>
    <div class="custom_modal_body">
      <form action="">
        <div class="col-lg-6 pdl-0 pdr-0 pdr-lg-3">
          <div class="form-group required dropdown pb-0">
            <label for=""> Main Document <span>*</span></label>
            <input class="form-control" type="text" [(ngModel)]="mainPhyDocumentName" #mainDocName="ngModel" name="mainPhyDocName" disabled />
          </div>
        </div>
        <div class="col-lg-6 pdr-0 pdl-0 pdl-lg-3">
          <div class="form-group required">
            <label for=""> Document Name <span>*</span></label>
            <input class="form-control" type="text" [(ngModel)]="txtPhysicaleDocumentName" #txtPhDocName="ngModel" (keypress)="alphaNumberOnly($event)" (paste)="onPaste($event)" name="DocName" required />
            <small class="text-danger" *ngIf="txtPhDocName.invalid && !IsPhysicalSignatureDocNameValid">
              <i class="fa fa-exclamation-circle" aria-hidden="true">
              </i> Please enter Document Name
            </small>
          </div>
        </div>
        <div class="clearfix clear-fix"></div>
        <div class="pos-relative mgb-3">
          <div class="draganddrop" appDragAndDropFile (fileDropped)="DragDropPhysicalSignatureDocs($event)">
            <div class="dragtext mx-auto">
              <h2>
                Drag and Drop
                your file here
                <br> or
              </h2>
              <button (click)="UploadPhysicalSignatureDocs()" [disabled]="IsDragDropBtn" [ngClass]="!IsDragDropBtn ? 'obtn-primary obtn-reg' : 'btnDisabled'">Browse Files</button>
              <input type="file" #PhysicalSignaturefileUpload class="file-upload" style="display: none;"
                     (change)="DragDropPhysicalSignatureDocs($event.target.files)" accept=".pdf">
            </div>
          </div>
        </div>
        <div role="alert" class="alert alert-warning pd-2 mgb-3">
          <strong>Notes:</strong> Maximum file size should be <b>20 MB</b> (Only <b>PDF file</b> is accepted)
        </div>
        <div class="documents_mainwrap" [ngClass]="UploadedPhysicalSignatureDoc.length > 0 ? 'mgb-3':''">
          <div class="doc_row" *ngFor="let item of UploadedPhysicalSignatureDoc;let i = index">
            <div class="doc_type">{{item.docType}}</div>
            <div class="doc_title">{{item.docName}}</div>
            <div class="doc_date">{{item.uploadedDate | date: 'MM/dd/yyyy, h:mm:ss a'}}</div>

            <div class="doc_action">
              <span>
                <img src="../assets/images/icons/ic-eye.svg" alt="ic-doc-view"
                     (click)="ViewUploadedDocs(item.uploadedFileData,item.uploadedFileName)" />
              </span>
              <span>

              </span>
              <button type="button" [disabled]="(item.uploadDocID > 0)? true:false"
                      (click)="DeleteUploadedPhysicalSignatureDoc(i,item.uploadDocID,item.docName)"
                      style="padding: 0;border: none;background: none;">
                <img src="../assets/images/icons/ic-delete.svg" alt="ic-doc-remove" />
              </button>
              <!-- <button type="button" *ngIf="item.uploadDocID != ''">Click</button> -->

            </div>
          </div>
        </div>
        <p class="instructions danger_text pd-2 font-10 mgb-3">
          Your privacy is very important to us. Ascendion is committed to keeping your personal data safe and
          secure. Our security measures include encryption of data, security controls that protect our
          infrastructure, training and data security policies.
        </p>
        <div class="btn_wrap_modal">
          <button class="obtn obtn-outline obtn-reg" (click)="ResetPhysicalSignatureDoc()"
                  [disabled]="IsphysicalSignatureDocDelAllDis">
            Reset
          </button> &nbsp;
          <button [ngClass]="!IsSubmitPhysicalSignatureDocBrn ? 'obtn obtn-primary obtn-reg' : 'obtn obtn-primary obtn-reg btnDisabled'" [disabled]="IsSubmitPhysicalSignatureDocBrn" (click)="SubmitPhysicalSignatureDoc()">Submit</button>
        </div>
      </form>
    </div>
  </div>
</div>
<div class="custom_modal" id="additionalDocs" [ngStyle]="{'display':AdditionalPopupStyle}">
  <div class="custom_modal_wrap custom_modal-width-md">
    <div class="custom_modal_header">
      <h5 class="modal-title">Upload Additional Documents</h5>
      <button class="close">
        <span>
          <img src="../assets/images/icons/ic-close.svg" alt="ic-close"
               (click)="OpenAdditionalDocsPopup()">
        </span>
      </button>
    </div>
    <div class="custom_modal_body pd-3">
      <form action="">
        <div class="col-lg-6 pdl-0 pdr-0 pdr-lg-3">
          <div class="form-group required dropdown pb-0">
            <label for=""> Main Document <span>*</span></label>
            <input class="form-control" type="text" [(ngModel)]="mainAddDocumentName" #mainDocName="ngModel" name="mainPhyDocName" disabled />
          </div>
        </div>
        <div class="col-lg-6 pdr-0 pdl-0 pdl-lg-3">
          <div class="form-group required">
            <label for=""> Document Name <span>*</span></label>
            <input class="form-control" type="text" [(ngModel)]="txtAdditionalDocumentName" #txtAddiDocName="ngModel" (keypress)="alphaNumberOnly($event)" (paste)="onPaste($event)" name="DocName" required />
            <small class="text-danger" *ngIf="txtAddiDocName.invalid && !IsAdditionalDocNameValid">
              <i class="fa fa-exclamation-circle" aria-hidden="true">
              </i> Please enter Document Name
            </small>
          </div>
        </div>
        <div class="clearfix clear-fix"></div>
        <div class="pos-relative mgb-3">
          <div class="draganddrop" appDragAndDropFile (fileDropped)="DragDropAdditionalDocs($event)">
            <div class="dragtext mx-auto">
              <h2>
                Drag and Drop
                your file here
                <br> or
              </h2>
              <button (click)="UploadAdditionalDocs()" [disabled]="IsDragDropBtnForAdditional" [ngClass]="!IsDragDropBtnForAdditional ? 'obtn-primary obtn-reg' : 'btnDisabled'">Browse Files</button>
              <input type="file" #AdditionalfileUpload class="file-upload" style="display: none;"
                     (change)="DragDropAdditionalDocs($event.target.files)" accept=".pdf">
            </div>
          </div>
        </div>
        <div role="alert"
             class="alert alert-warning pd-2 mgb-3">
          <strong>Notes:</strong> Maximum file size should be <b>20 MB</b> (Only <b>PDF file</b> is accepted)
        </div>
        <div class="documents_mainwrap" [ngClass]="UploadedAdditionalDocsList.length > 0 ? 'mgb-3':''">
          <div class="doc_row" *ngFor="let item of UploadedAdditionalDocsList;let i = index">
            <div class="doc_type">{{item.docType}}</div>
            <div class="doc_title">{{item.docName}}</div>
            <div class="doc_date">{{item.uploadedDate | date: 'MM/dd/yyyy, h:mm:ss a'}}</div>

            <div class="doc_action">
              <span>
                <img src="../assets/images/icons/ic-eye.svg" alt="ic-doc-view"
                     (click)="ViewUploadedDocs(item.uploadedFileData,item.uploadedFileName)" />
              </span>
              <span>

              </span>
              <button type="button" [disabled]="(item.uploadDocID > 0)? true:false"
                      (click)="DeleteUploadedAdditionalDoc(i,item.uploadDocID,item.docName)"
                      style="padding: 0;border: none;background: none;">
                <img src="../assets/images/icons/ic-delete.svg" alt="ic-doc-remove" />
              </button>
              <!-- <button type="button" *ngIf="item.uploadDocID != ''">Click</button> -->

            </div>
          </div>
        </div>
        <p class="instructions danger_text pd-2 font-10 mgb-3">
          Your privacy is very important to us. Ascendion is committed to keeping your personal data safe and
          secure. Our security measures include encryption of data, security controls that protect our
          infrastructure, training and data security policies.
        </p>
        <div class="btn_wrap_modal">
          <button class="obtn obtn-outline obtn-reg" (click)="ResetAdditionalDoc()"
                  [disabled]="IsAdditionalDocDelAllDis">
            Reset
          </button> &nbsp;
          <button [ngClass]="!IsSubmitAdditionalDocBtn ? 'obtn obtn-primary obtn-reg' : 'obtn obtn-primary obtn-reg btnDisabled'" [disabled]="IsSubmitAdditionalDocBtn" (click)="SubmitAdditionalDoc()">Submit</button>
        </div>
      </form>
    </div>
  </div>
</div>
<div class="custom_modal" id="supportingDocs" [ngStyle]="{'display':supportingDocStyle}">
  <div class="custom_modal_wrap custom_modal-width-md">
    <div class="custom_modal_header">
      <h5 class="modal-title">Document Upload</h5>
      <button class="close">
        <span><img src="../assets/images/icons/ic-close.svg" alt="ic-close" (click)="OpenSupportDocPopup(1,0,1,'')" /></span>
      </button>
    </div>
    <div class="custom_modal_body">
      <div class="col-lg-6 pdl-0 pdr-0 pdr-lg-3">
        <div class="form-group required dropdown pb-0" *ngIf="!IsSupportingDocsForDocId">
          <label for="">Select Document Type <span>*</span></label>
          <span class="has-icon">
            <select class="form-control" name="docType" [(ngModel)]="SelectedDocType" #docType="ngModel" required
                    #SelectedDocText id="supportingDoc">
              <option [ngValue]="null">---Select---</option>
              <option *ngFor="let item of docTypes" [value]="item.value">
                {{item.Text}}
              </option>
            </select>
            <i class="con fa-solid fa-angle-down font-16 mgr-2"></i>
          </span>
          <small class="text-danger" *ngIf="docType.invalid && !IsSupportingTypeValid">
            <i class="fa fa-exclamation-circle" aria-hidden="true">
            </i> Please select Document Type
          </small>
        </div>
        <div class="form-group required dropdown pb-0" *ngIf="IsSupportingDocsForDocId">
          <label for=""> Main Document <span>*</span></label>
          <input class="form-control" type="text" [(ngModel)]="mainDocumentName" #mainDocName="ngModel" name="mainDocName" disabled />
        </div>
      </div>
      <div class="col-lg-6 pdr-0 pdl-0 pdl-lg-3">
        <div class="form-group required">
          <label for="">Supporting Document Name <span>*</span></label>
          <input class="form-control" type="text" [(ngModel)]="txtDocumentName" #txtDocName="ngModel" name="DocName" (keypress)="alphaNumberOnly($event)" (paste)="onPaste($event)" required />
          <small class="text-danger" *ngIf="txtDocName.invalid && !IsSupportingDocNameValid">
            <i class="fa fa-exclamation-circle" aria-hidden="true">
            </i> Please enter Supporting Document Name
          </small>
        </div>
      </div>
      <div class="clearfix clear-fix"></div>
      <div class="pos-relative mgb-3">
        <div class="draganddrop" appDragAndDropFile (fileDropped)="UploadedFile($event)">
          <div class="dragtext mx-auto">
            <h2>
              Drag and Drop
              your file here
              <br> or
            </h2>
            <button (click)="UploadSupportingDocs()" class="obtn obtn-primary obtn-reg">Browse Files</button>
            <input type="file" #fileUpload class="file-upload" style="display: none;"
                   (change)="UploadedFile($event.target.files)" accept=".pdf">
          </div>
        </div>
      </div>
      <div role="alert"
           class="alert alert-warning pd-2 mgb-3">
        <strong>Notes:</strong> Maximum file size should be <b>20 MB</b> (Only <b>PDF file</b> is accepted)
      </div>
      <div class="documents_mainwrap" [ngClass]="UploadedSupportingDocs.length > 0 ? 'mgb-3':''">
        <div class="doc_row" *ngFor="let item of UploadedSupportingDocs;let i = index">
          <div class="doc_type">{{item.docType}}</div>
          <div class="doc_title">{{item.docName}}</div>
          <div class="doc_date">{{item.sent_date | date: 'MM/dd/yyyy, h:mm:ss a'}}</div>
          <div class="doc_action">
            <span>
              <i class="fa-solid fa-eye text-color-action font-14 cursor-pointer"
                 (click)="ViewUploadedDocs(item.docData==null?item.uploadedFileData:item.docData,item.uploadedFileName)"></i>
            </span>
            <span>
              <i class="fa-solid fa-trash-can text-color-action font-14 cursor-pointer" [disabled]="(item.DocID > 0)? true:false"
                 (click)="DeleteSupportingDocs(i,item.DocID,item.docName,item.id,item.isExist)"></i>
            </span>
          </div>
        </div>
      </div>
      <p class="instructions danger_text pd-2 font-10 mgb-3">
        Your privacy is very important to us. Ascendion is committed to keeping your personal data safe and secure.
        Our security measures include encryption of data, security controls that protect our infrastructure, training
        and data security policies.
      </p>
      <div class="btn_wrap_modal">
        <button class="obtn obtn-outline obtn-reg" (click)="ResetSupportingDocs()" [disabled]="IsSupportingDocDelAllDis">Reset</button>
        <button [ngClass]="!IsSupportingbtndisabled ? 'obtn obtn-primary obtn-reg mgl-3' : 'obtn obtn-primary obtn-reg mgl-3 btnDisabled'" (click)="SubmitSupportingDocs()" [disabled]="IsSupportingbtndisabled">Add & Close</button>
      </div>
      <!-- </form> *ngIf="item.isExist!=1"-->
    </div>
  </div>
</div>

<div [ngClass]="RejectionInfoPopupclass" class="custom_modal notes_modal" id="rejectionInfo_modal">
  <div class="custom_modal_wrap">
    <div class="custom_modal_header">
      <h5 class="modal-title">Rejection Notes</h5>
      <button class="close" (click)="RejectionInfoPopup('close', $event)">
        <span>
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="14" height="14"
               viewBox="0 0 14 14">
            <defs>
              <path id="x997k9vwqa"
                    d="M14 1.41L12.59 0 7 5.59 1.41 0 0 1.41 5.59 7 0 12.59 1.41 14 7 8.41 12.59 14 14 12.59 8.41 7z" />
            </defs>
            <g fill="none" fill-rule="evenodd">
              <g>
                <g>
                  <g>
                    <g transform="translate(-1146 -528) translate(496 505) translate(1 17) translate(649 6)">
                      <use fill="#4A4A4A" xlink:href="#x997k9vwqa" />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </span>
      </button>
    </div>
    <div class="custom_modal_body col-12 pd-0">
      <div class="popup_body col-12 pd-0">
        <div id="" class="col-md-12 p-0 d-flex flex-wrap">
          <!-- <div id="" class="col-sm-6 p-0 pr-2 popup-left-col pb-2">
              <div class="col-sm-12 p-0" >
                  <h6 class="text-center header">Consultant</h6>
              </div>
            <div class="row m-0 RejectionHistoryCNS pb-2" *ngFor="let CNS of RejectionHistoryCNS" >
              <div class="col-sm-12 rej_req_info RejNotesTitle">
                <p>Notes</p>
                <small style=" word-wrap:break-word;">{{CNS.Reject_Reason}}</small>
              </div>
              <div class="col-sm-6 rej_req_info">
                <p>Signed Date</p>
                <small>{{CNS.ActivityDate}}</small>
              </div>
              <div class="col-sm-6 rej_req_info">
                <p>Rejected Date</p>
                <small>{{CNS.RejectedDate}}</small>
              </div>
              <div class="col-sm-6 rej_req_info">
                <p>Rejected By</p>
                <small>{{CNS.RejectedBy}}</small>
              </div>
              </div>
          </div> -->
          <div id="" class="col-sm-12 p-0 pl-2 pb-2">
            <div class="col-12 pd-3 m-0" *ngFor="let OPS of RejectionHistoryOPS">
              <div class="col-sm-6">
                <div class="form-group mg-0">
                  <label>Rejected Date</label>
                  <p class="form-control-value mg-0 pd-0">{{OPS.RejectedDate}}</p>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group mg-0">
                  <label>Rejected By</label>
                  <p class="form-control-value mg-0 pd-0">{{OPS.RejectedBy}}</p>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="form-group mg-0">
                  <label>Notes</label>
                  <p class="form-control-value mg-0 pd-0" style="line-height: normal!important;">{{OPS.Reject_Reason}}</p>
                </div>
              </div>
              <div class="clearfix clear-fix"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix clear-fix"></div>
    </div>
  </div>
</div>
<!-- <div [ngClass]="RejectPopupclass" class="custom_modal notes_modal" id="reject_notes_modal">
  <div class="custom_modal_wrap">
    <div class="custom_modal_header">
      <h5 class="modal-title">Rejection Notes</h5>
      <button class="close" (click)="RejectPopupOpen('close')">
        <span>
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="14" height="14" viewBox="0 0 14 14">
            <defs>
                <path id="x997k9vwqa" d="M14 1.41L12.59 0 7 5.59 1.41 0 0 1.41 5.59 7 0 12.59 1.41 14 7 8.41 12.59 14 14 12.59 8.41 7z"/>
            </defs>
            <g fill="none" fill-rule="evenodd">
                <g>
                    <g>
                        <g>
                            <g transform="translate(-1146 -528) translate(496 505) translate(1 17) translate(649 6)">
                                <use fill="#4A4A4A" xlink:href="#x997k9vwqa"/>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
        </span>
      </button>
    </div>
    <div class="custom_modal_body">
      <div *ngIf="RejectionNotesError"  class="text-danger">
        <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
        <b>Please enter Rejection Notes</b>
      </div>
      <div class="form_control required mb-3">
        <label for="">Notes <span>*</span></label>
        <textarea rows="4" [(ngModel)]="RejectionNotes" placeholder="Notes"></textarea>
      </div>
      <div class="confirmation_btn">
        <button class="close" (click)="RejectPopupOpen('close')">Cancel</button>
        <button class="confirm_btn" (click)="Reject()">Save</button>
      </div>
    </div>
    </div>
</div> -->
<!-- Send Mail Popup-->
<div [ngClass]="emailsendWrapStyle" class="custom_modal" id="emailWrap">
  <div class="custom_modal_wrap" style="width: 70% !important;">
    <div class="custom_modal_header pd-2">
      <h5 class="modal-title">Send Email Message</h5>
      <button class="close">
        <span><img src="../../assets/images/icons/ic-close.svg" alt="ic-close" (click)="SendEmailPopup('','','','',0)" /></span>
      </button>
    </div>
    <div class="custom_modal_body">
      <div class="email_det">
        <div class="row">
          <div class="col-sm-12 mail_details">
            <table style="width: 100%;">
              <tr>
                <td>
                  <b>To : &nbsp; </b>
                </td>
                <td>
                  <input type="text" class="form-control" name="txtMailTo" placeholder="Vendor Email ID"
                         [(ngModel)]="MailTo" required>
                </td>
                <br />
                <div *ngIf="IsMailToError" class="text-danger font-10">
                  <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                  <b> Please enter email To</b>
                </div>
              </tr>
              <tr>
                <td>
                  <b>CC : &nbsp; </b>
                </td>
                <td>
                  <input type="text" class="form-control" name="txtMailCC" placeholder="Email ID"
                         [(ngModel)]="MailCC" required>
                </td>
                <br />
                <div *ngIf="IsMailCCError" class="text-danger font-10">
                  <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                  <b> Please enter email CC</b>
                </div>
              </tr>
              <tr>
                <td>
                  <b>Subject: </b>
                </td>
                <td>
                  <input type="text" class="form-control" name="txtMailSubject" placeholder="Mail Subject"
                         [(ngModel)]="MailSubject" required>
                </td>
                <br />
                <div *ngIf="IsMailSubjectError" class="text-danger font-10">
                  <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                  <b> Please enter Subject</b>
                </div>
              </tr>
              <tr>
                <td><b>Mail Body : &nbsp; </b></td>
                <td>
                  <!-- <input type="text" name="txtMailBody" [(ngModel)]="MailBody" required> -->
                  <!-- <textarea id="w3review" class="form-control" style="height: 200px;" name="txtMailBody"
                    [(ngModel)]="MailBody" required>
                  </textarea> -->
                  <div class="form-control textarea-editor" id="mailMessage" contenteditable="true"
                       [innerHTML]="sanitizer.bypassSecurityTrustHtml(MailBody)" style="height: 200px;"></div>
                </td>
                <br />
                <div *ngIf="IsMailBodyError" class="text-danger font-10">
                  <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                  <b> Please enter Message</b>
                </div>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="pts_btnWrap  text-right">
      <button type="button" class="obtn obtn-outline obtn-reg" (click)="SendEmailPopup('','','','',0)">Cancel</button>
      <button type="button" [ngClass]="!IsSendMailBtn ? 'obtn obtn-primary obtn-reg mgl-3' : 'obtn obtn-primary obtn-reg mgl-3 btnDisabled'" [disabled]="IsSendMailBtn" (click)="SendEmail()">Send & Close</button>
    </div>
  </div>
</div>
